import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import {
  defaultTellingen,
  type EnvironmentSettings,
  type LinkItem,
} from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Maatwerk, {
  isVisible: (settings: EnvironmentSettings) =>
    (settings.isActiveAdviseur || settings.isInterneGebruiker) &&
    (settings.isActiveAdviseur || settings.isMaatschappij || settings.isInterneGebruiker),
  create: (settings: EnvironmentSettings): LinkItem => {
    const tellingen = settings.tellingen ?? defaultTellingen;

    return {
      itemtype: 'link',
      menuItem: MenuItems.Maatwerk,
      title: 'Maatwerk',
      url: '/app/aanvraag/recente-activiteiten/maatwerk',
      iconclass: 'fas fa-ruler',
      showbadge: !!tellingen.aantalMaatwerk,
      badgecontent: tellingen.aantalMaatwerk,
      target: '_top',
    };
  },
});
